(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["iw-catalog-menu"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Ritual caps this dropdown at 320px with a rule normal CSS can't override,
       so size the Catalog panel (and make it white) with inline styles. */
    function sizePanel() {
      document.querySelectorAll('[data-iw-cat]').forEach(function (root) {
        var sub = root.closest('.menu-list__submenu');
        if (!sub) return;
        sub.style.setProperty('left', '0', 'important');
        sub.style.setProperty('right', '0', 'important');
        sub.style.setProperty('width', 'auto', 'important');
        sub.style.setProperty('max-width', 'none', 'important');
        sub.style.setProperty('background-color', '#fff', 'important');
      });
    }

    function activate(link) {
      var root = link.closest('[data-iw-cat]');
      if (!root) return;
      var i = link.getAttribute('data-iw-index');
      root.querySelectorAll('.is-active').forEach(function (el) { el.classList.remove('is-active'); });
      link.classList.add('is-active');
      var panel = root.querySelector('[data-iw-panel="' + i + '"]');
      if (panel) panel.classList.add('is-active');
    }

    function handler(e) {
      var link = e.target.closest && e.target.closest('.iw-cat__link');
      if (link) activate(link);
      /* re-apply in case the theme re-rendered the header */
      if (e.target.closest && e.target.closest('.menu-list__list-item')) sizePanel();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sizePanel);
    } else {
      sizePanel();
    }
    document.addEventListener('pointerover', handler);
    document.addEventListener('focusin', handler);
  })();
  } catch(e) { console.error(e); }
})();

})();
